import React from 'react';
import Image from '../../component/Image/Image';

var MimeType = require('./../../constants/mimeType').mimeTypes;
const imageMimeTypeExtensions = require('./../../constants/mimeType').imageMimeTypeExtensions;
var FileItemsClassName = {};

FileItemsClassName[MimeType.TEXT_XML] = 'fa-file-code-o';
FileItemsClassName[MimeType.TEXT_CSV] = 'fa-file-text-o';
FileItemsClassName[MimeType.APPLICATION_MS_EXCEL] = 'fa-file-excel-o';
FileItemsClassName[MimeType.APPLICATION_MS_EXCEL_OPEN_XML] = 'fa-file-excel-o';


var FileItem = React.createClass({

  propTypes: {
    name: React.PropTypes.node,
    mimeType: React.PropTypes.string,
    previewUrl: React.PropTypes.string
  },

  getDefaultProps(){
    return {
      mimeType: null
    }
  },

  render(){
    var { previewUrl, mimeType, name } = this.props;
    var className = 'file-item-icon txt-color-blue fa ' + this._getClassNameByMimeType(mimeType);

    return (
      <div className="file-item" title={name}>

        <i display-if={!this._isImageFile()} className={className}/>
        <div
          display-if={this._isImageFile()}
          className="file-item-image-container"
        >
          <Image src={previewUrl} />
        </div>

        {name && <div className="file-item-name">{name}</div>}
        {this.props.children}
      </div>
    )
  },

  _isImageFile() {
    return imageMimeTypeExtensions.isWebSupportedImage(this.props.mimeType);
  },

  _getClassNameByMimeType(mimeType){
    if (!this._isImageFile()) {
      return 'fa-file-image-o';
    }

    return FileItemsClassName.hasOwnProperty(mimeType)
      ? FileItemsClassName[mimeType]
      : "fa-file-o";
  }

});


module.exports = FileItem;
